import { render, staticRenderFns } from "./CategoriesManager.vue?vue&type=template&id=07895eda&"
import script from "./CategoriesManager.vue?vue&type=script&lang=js&"
export * from "./CategoriesManager.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports